import Form from '../form/Form';
import {h} from 'preact';
import FieldGroup from '../form/FieldGroup';
import {useCallback, useEffect} from 'preact/hooks';
import Button from '../form/Button';
import {CommandStatus} from '../../../../framework/type';
import useCommandErrors from '../../../../framework/hook/useCommandErrors';
import commandsAreRunning from '../../../../framework/commandsAreRunning';
import {Job} from '../../model/Job';
import Paragraph from '../media/Paragraph';
import {useArchiveJobsCommand} from '../../command/archiveJobs';
import currentUserTeam from '../../query/currentUserTeam';

interface Props {
  jobs: Job[];
  onCancel(): void;
  onSuccess(): void;
}

export default function ArchiveJobsForm({jobs, onCancel, onSuccess}: Props) {
  const team = currentUserTeam();

  const [command, archiveJobs] = useArchiveJobsCommand();
  const {system} = useCommandErrors(command);
  const isLoading = commandsAreRunning(command);

  const submit = useCallback(() => {
    if (jobs.length === 0 || isLoading || !team) return;

    archiveJobs({
      teamId: team.id,
      jobIds: jobs.map(job => job.id)
    })
  }, [jobs, team, isLoading, archiveJobs]);

  useEffect(() => {
    if (!command || command.status !== CommandStatus.SUCCESS) return;
    onSuccess();
  }, [command]);

  return (
    <Form heading="Archive Jobs" onSubmit={submit} error={system}>
      <Paragraph>This will archive the following jobs:</Paragraph>
      <ul>
        {jobs.map(job => (
          <li>{job.name}</li>
        ))}
      </ul>
      <FieldGroup horizontal={true}>
        <Button primary={true} type="submit" disabled={isLoading} onClick={submit}>Archive</Button>
        <Button type="cancel" onClick={onCancel}>Cancel</Button>
      </FieldGroup>
    </Form>
  )
}